export enum DomainEnum
{
    //educacaoadventista = 'eadv.org.br',
    educacaoadventista = 'educacaoadventista.org.br',
    externo_br = 'sistemainterativo.com.br',
    externo_es = 'acesclass.org',
    eaportal = 'eaportal.org',
    dev = 'testecpb.com.br'
}
